import { createApp } from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import router from './router'
import store from './store'

import gv from './mixin/globalValiables'
import ga from './mixin/globalActions'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-icons';
import 'bootstrap-icons/font/bootstrap-icons.css'

import './assets/base/base.css'
import './assets/css/common.css'

import './validate/validate'

import 'feather-icons'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BsSelect from './components/atoms/BsSelect.vue'

library.add(faBarcode)

const app = createApp(App)
app.use(router)
app.use(store)
app.mixin(ga)
app.mixin(gv)
app.use(VueAxios, axios)
app.component('fa', FontAwesomeIcon)
app.mount('#app')
app.component('bs-select', BsSelect)
